import {ref} from 'vue';

export default {
    install: (app, options) => {
        const userSubscriptionStatuses = ref([]);

        const loadUserSubscriptionStatuses = ($status = '') => {
            // if (userSubscriptionStatuses.value.length === 0) {
                window.lazy_axios.get(`/users/subscription-statuses?status=${$status}`)
                    .then((response) => {
                        if (response.data.statuses) {
                            userSubscriptionStatuses.value = response.data.statuses;
                            // document.dispatchEvent(new CustomEvent('loaded.profile'));
                        }
                    });
            // }
        };

        app.provide('userSubscriptionStatuses', userSubscriptionStatuses);
        app.provide('loadUserSubscriptionStatuses', loadUserSubscriptionStatuses);
    },
}
